import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { processContactData } from '../../utils/DrupalEntityTypes/Community/CommunityHelpers';

const CommunityContact = ( { className, pre, post, communityData, salesCounselorData } ) => {
  const {
    phone,
    email,
    name
  } = processContactData( communityData, salesCounselorData );

  return phone && email && (
    <div className={className}>

      <span>
        { pre }

        { name }

        { email && (
          <>
            {' '}
            at
            {' '}
            <a href={`mailto:${email}`}>{email}</a>
          </>
        )}
      </span>

      { phone && (
        <span>
          { email
            ? <> or </>
            : <> at </>}
          { phone }
          {' '}
          { post }
        </span>
      )}

    </div>
  ) || null;
};

CommunityContact.propTypes = {
  className: PropTypes.string,
  pre: PropTypes.string,
  post: PropTypes.string,
  communityData: PropTypes.shape( {
    email: PropTypes.string,
    phone: PropTypes.string,
  } ),
  salesCounselorData: PropTypes.shape( {
    mail: PropTypes.string,
    fieldPhone: PropTypes.string,
    fieldFirstName: PropTypes.string,
  } ),
};

CommunityContact.defaultProps = {
  className: '',
  pre: 'Contact ',
  post: ' if you have questions.',
  communityData: {},
  salesCounselorData: {},
};

export default CommunityContact;
